import Vue from 'vue'
import App from './App'
import router from './router'
import api from './http'
import i18n from './i18n'
import store from './store'

import 'font-awesome/css/font-awesome.min.css'

// element ui
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';

import animated from 'animate.css'

import '@/styles/universal.scss' // global css
// import '@/styles/element-cover.scss' // global css

import '@/permission';

import moment from "moment";
moment.locale('zh-cn');
Vue.prototype.$moment = moment;

// global pinyin match
// import PinyinMatch from 'pinyin-match';
// Vue.prototype.$pinyinmatch = PinyinMatch;

// import pinyin from "pinyin";
// Vue.prototype.$pinyin = pinyin;

// global method
import utility from "@/utils/utility";
Vue.prototype.$utility = utility;


import dict from "@/utils/dict";
Vue.prototype.$dict = dict;

// Vue.use(ElementUI);
Vue.use(api)

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	i18n,
	store,
	components: { App },
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js